import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cfde629e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cfde629e&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=cfde629e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfde629e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/about/about-top-cell/index.vue
// module id = null
// module chunks = 